var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "muti-instance",
          attrs: {
            title: "多实例配置",
            visible: _vm.dialogVisible,
            width: "500px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c("el-alert", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: { type: "info", closable: false, "show-icon": "" },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [
                    _vm._v(
                      "\n        按照BPMN2.0规范的要求，用于为每个实例创建执行的父执行，会提供下列变量:"
                    ),
                    _c("br"),
                    _vm._v("\n        nrOfInstances：实例总数。"),
                    _c("br"),
                    _vm._v(
                      "\n        nrOfActiveInstances：当前活动的（即未完成的），实例数量。对于顺序多实例，这个值总为1。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n        nrOfCompletedInstances：已完成的实例数量。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n        loopCounter：给定实例在for-each循环中的index。"
                    ),
                    _c("br"),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("x-form", {
            ref: "xForm",
            attrs: { config: _vm.formConfig },
            model: {
              value: _vm.formData,
              callback: function ($$v) {
                _vm.formData = $$v
              },
              expression: "formData",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }